const SettingOption = {
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED',
};

export {
  SettingOption,
};
